<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue">Risk Assessments</span>
  </h4>

  <div
    class="progress"
    style="margin-bottom: 10px; margin-left: 30px; margin-right: 30px"
  >
    <div
      class="progress-bar progress-bar-success"
      role="progressbar"
      aria-valuenow="40"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 40%; background-color: green"
    >
      40% Complete (Vehicle Malfunctions)
    </div>
  </div>

  <div
    class="progress"
    style="margin-bottom: 10px; margin-left: 30px; margin-right: 30px"
  >
    <div
      class="progress-bar progress-bar-info"
      role="progressbar"
      aria-valuenow="50"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 50%"
    >
      50% Complete (Arms Malfunctions)
    </div>
  </div>

  <div
    class="progress"
    style="margin-bottom: 10px; margin-left: 30px; margin-right: 30px"
  >
    <div
      class="progress-bar progress-bar-warning"
      role="progressbar"
      aria-valuenow="60"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 60%; background-color: darkorange"
    >
      60% Complete (Infrastructure Strength)
    </div>
  </div>

  <div
    class="progress"
    style="margin-bottom: 10px; margin-left: 30px; margin-right: 30px"
  >
    <div
      class="progress-bar progress-bar-danger"
      role="progressbar"
      aria-valuenow="70"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 70%; background-color: darkred"
    >
      70% Complete (Food Contamination)
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
